import { compactInputClass } from "@/components/common/surfaceClasses";

type Props = {
  manufacturerOptions: Array<{ id: string; name: string }>;
  useMfgScenarios: boolean;
  setUseMfgScenarios: (v: boolean) => void;
  mfgSourceId: string;
  setMfgSourceId: (v: string) => void;
  freezeKbDigest: boolean;
  setFreezeKbDigest: (v: boolean) => void;
  saving: boolean;
  saveOrgFlags: () => void | Promise<void>;
};

export function RoleplayOrgSettingsCollapsible(props: Props) {
  const vm = props;
  return (
    <details className="rounded-lg border border-amber-200 bg-amber-50 text-xs text-amber-900 group dark:border-amber-900/70 dark:bg-amber-950/30 dark:text-amber-200">
      <summary className="cursor-pointer select-none px-3 py-2.5 font-semibold flex items-center justify-between gap-2 list-none [&::-webkit-details-marker]:hidden">
        <span>Manufacturer &amp; KB digest settings</span>
        <span className="text-amber-700 shrink-0 transition-transform group-open:rotate-90" aria-hidden>
          ▸
        </span>
      </summary>
      <div className="px-3 pb-3 pt-0 space-y-3 border-t border-amber-200/70 dark:border-amber-900/50">
        <div className="font-semibold text-[11px] uppercase tracking-wide text-amber-950/80 pt-1 dark:text-amber-200/90">Subscriber org</div>
        {vm.manufacturerOptions.length > 0 ? (
          <label className="flex items-start gap-2">
            <input
              type="checkbox"
              className="mt-0.5 shrink-0"
              checked={vm.useMfgScenarios}
              onChange={(e) => vm.setUseMfgScenarios(e.target.checked)}
            />
            <span>Include sharable scenarios from manufacturer catalog</span>
          </label>
        ) : (
          <p className="text-[11px] leading-relaxed">
            No manufacturer links on this org — only this org&apos;s scenarios (and the optional platform example for trainers) apply.
          </p>
        )}
        {vm.manufacturerOptions.length > 1 ? (
          <div className="flex flex-col gap-1">
            <span className="text-[11px] font-medium text-amber-950/90 dark:text-amber-200/90">Manufacturer org</span>
            <select
              className={`w-full max-w-md text-xs border-amber-300 ${compactInputClass}`}
              value={vm.mfgSourceId}
              onChange={(e) => vm.setMfgSourceId(e.target.value)}
            >
              {vm.manufacturerOptions.map((m) => (
                <option key={m.id} value={m.id}>
                  {m.name}
                </option>
              ))}
            </select>
          </div>
        ) : null}
        <label className="flex items-start gap-2 pt-1">
          <input type="checkbox" className="mt-0.5 shrink-0" checked={vm.freezeKbDigest} onChange={(e) => vm.setFreezeKbDigest(e.target.checked)} />
          <span className="leading-relaxed">
            When a scenario has a KB digest, use it instead of live KB on each turn (requires digest text on the scenario row).
          </span>
        </label>
        <div className="flex justify-center pt-2">
          <button
            type="button"
            disabled={vm.saving}
            onClick={() => void vm.saveOrgFlags()}
            className="px-4 py-2 rounded-lg bg-indigo-600 text-white text-xs font-semibold hover:bg-indigo-700 disabled:opacity-50"
          >
            Save roleplay org settings
          </button>
        </div>
      </div>
    </details>
  );
}
